import { StanModal } from '@/components';
import { useUpgradeFunnelTheme } from '../../../queries/useFunnelThemeMutations';

interface UpgradeFunnelThemeModalProps {
    isOpen: boolean;
    onClose: () => void;
    storeId: number;
}

/**
 * Confirmation modal for upgrading a legacy funnel to the new store theme.
 * Calls PUT /v1/stores/:storeId/change-theme which removes custom colors
 * so the funnel inherits from the user's linksite store theme.
 *
 * Matches Vue UpgradeFunnelThemeModal.vue behavior.
 */
export const UpgradeFunnelThemeModal = ({ isOpen, onClose, storeId }: UpgradeFunnelThemeModalProps) => {
    const upgradeFunnelTheme = useUpgradeFunnelTheme(storeId);

    const handleUpgrade = () => {
        upgradeFunnelTheme.mutate(undefined, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <StanModal
            id='upgrade-funnel-theme-modal'
            isOpen={isOpen}
            onClose={onClose}
            title='Upgrade Funnel Design'
            primaryActionLabel='Upgrade Funnel Design'
            primaryActionLoading={upgradeFunnelTheme.isPending}
            primaryActionDisabled={upgradeFunnelTheme.isPending}
            onPrimaryAction={handleUpgrade}
        >
            <p className='text-body-md text-gray'>
                Heads up! The old funnel design you&apos;re using now has custom colors set. Switching to the new design
                will permanently set your funnel to your store theme.
            </p>
        </StanModal>
    );
};
